import qs from 'qs'
import axios from 'axios'
import store from '@/store/index'
import { ElMessage } from 'element-plus'
import { translate } from '@/utils/i18n'

window.BASE_URL = process.env.VUE_APP_FLAG
const service = axios.create({
  baseURL: window.BASE_URL, // api 的 base_url
  timeout: 0, // 请求超时时间，为0表示不设置超时时间
})

// request拦截器
service.interceptors.request.use(
  config => {
    const accessToken = JSON.parse(localStorage.getItem('accessToken')) || ''
    config.headers['Lang'] = localStorage.getItem('language')
    if (accessToken) {
      config.headers['Mate-Auth'] = `Bearer ${accessToken.value}`
      // config.headers['Content-Type'] = 'application/json;charset=UTF-8' // axios自动设置，手动设置后会导致上传图片失败
      config.headers['Version'] = 'v1'
      config.headers['Client-Type'] = 'data-center'
    }
    if (config.data && config.headers['Content-Type'] == 'application/x-www-form-urlencoded;charset=UTF-8') {
      config.data = qs.stringify(config.data)
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// response拦截器
service.interceptors.response.use(
  response => {
    // 下载请求
    if (response.config.responseType && response.config.responseType == 'blob') {
      return response
    }
    // 常规请求
    if (response.status === 200) {
      if (response.data.code && response.data.code === 200) {
        return response.data
      } else {
        ElMessage({ type: 'warning', showClose: true, message: response.data.msg || translate('网络请求失败，请稍候再试') })
        return Promise.reject(response.data)
      }
    } else {
      ElMessage({ type: 'warning', showClose: true, message: response.data.msg || translate('网络请求失败，请稍候再试') })
      return Promise.reject(response.data)
    }
  },
  error => {
    if (error.response.status == 401) {
      store.dispatch('logOut')
      localStorage.setItem('LoginStatusHasExpired', '登录状态已过期')
      location.href = `${location.origin}`
      return Promise.reject(error)
    }
    ElMessage({ type: 'warning', showClose: true, message: error.response.data.msg || translate('网络请求失败，请稍候再试') })
    return Promise.reject(error)
  }
)

export default service
